import { Autocomplete, ListItem, TextField, Typography } from "@mui/material";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import { stringComparerBy } from "@entrilia/shared/utilities/arrayHelper";
import type { TableColumnDefinition } from "./columnDefinitions";

interface Props {
  items: TableColumnDefinition[];
  onAdd: (columnId: string) => void;
  onCancel: () => void;
}

const AddColumnSelect = ({ items, onAdd, onCancel }: Props) => {
  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Escape") {
      e.stopPropagation();
      e.preventDefault();
      onCancel();
    }
  };

  return (
    <ListItem secondaryAction={<CloseIconButton onClick={onCancel} />}>
      <Autocomplete
        fullWidth
        openOnFocus
        options={[...items].sort(stringComparerBy((i) => i.title))}
        getOptionLabel={({ title }) => title}
        onChange={(_, item) => item && onAdd(item.id)}
        renderInput={(inputProps) => (
          <TextField {...inputProps} autoFocus placeholder="Type column name..." onKeyDown={handleInputKeyDown} />
        )}
        renderOption={({ key: _key, ...props }, option) => (
          <ListItem key={option.id} {...props}>
            <Typography>{option.title}</Typography>
          </ListItem>
        )}
      />
    </ListItem>
  );
};

export default AddColumnSelect;
